<template>
  <div class="modal fade" id="detailsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">

        <div class="modal-header border-bottom pb-3">
          <div>
            <h5 class="modal-title text-title mb-1" id="detailsModalLabel">
              Detalle de Venta
              <span v-if="venta" class="ms-2">
                <span class="badge fs-13 px-2 py-1" :class="tipoBadge">{{ tipoDoc }}</span>
                <span class="text-purple fw-bold ms-2">{{ venta.comprobante }}</span>
              </span>
            </h5>
            <div v-if="venta" class="text-muted fs-13">{{ formatFecha(venta.fecha) }} · {{ venta.almacen }}</div>
          </div>
          <button type="button" class="btn-close p-0" data-bs-dismiss="modal" aria-label="Cerrar">
            <img src="../../../assets/img/icons/close-circle-2.svg" alt="Cerrar" />
          </button>
        </div>

        <div class="modal-body">

          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-purple" role="status"></div>
            <p class="mt-2 text-muted fs-14">Cargando detalle...</p>
          </div>

          <div v-else-if="error" class="alert alert-danger fs-14">{{ error }}</div>

          <template v-else-if="venta">

            <!-- Cabecera info -->
            <div class="row g-3 mb-3">
              <div class="col-sm-3">
                <div class="detail-card">
                  <div class="detail-label">VENDEDOR</div>
                  <div class="detail-value text-purple">{{ venta.vendedor || '—' }}</div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="detail-card">
                  <div class="detail-label">CLIENTE</div>
                  <div class="detail-value">{{ clienteDisplay }}</div>
                  <div v-if="venta.cliente_doc" class="text-muted" style="font-size:11px">{{ venta.cliente_doc }}</div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="detail-card">
                  <div class="detail-label">CONDICIÓN</div>
                  <div class="detail-value">{{ venta.condicion || 'Contado' }}</div>
                  <div v-if="venta.fecha_venc" class="mt-1">
                    <span style="font-size:11px;color:#6c757d">Vence: </span>
                    <span :style="estaVencido ? 'font-size:12px;color:#dc3545;font-weight:600' : 'font-size:12px;color:#198754;font-weight:600'">
                      {{ formatFecha(venta.fecha_venc) }}
                    </span>
                  </div>
                  <div v-if="venta.ndiasvenc > 0 && !venta.fecha_venc" style="font-size:11px;color:#6c757d">
                    {{ venta.ndiasvenc }} días
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="detail-card">
                  <div class="detail-label">ALMACÉN</div>
                  <div class="detail-value">{{ venta.almacen || '—' }}</div>
                </div>
              </div>
            </div>

            <!-- Tabla ítems -->
            <div class="table-responsive">
              <table class="table align-middle mb-0 detail-tbl">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>PRODUCTO</th>
                    <th>PRESENTACIÓN</th>
                    <th class="text-center">CANT.</th>
                    <th class="text-end">ETIQUETA</th>
                    <th class="text-end">P. COBRADO</th>
                    <th class="text-end">SUBTOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in itemsPositivos" :key="item.id">
                    <td class="fw-semibold text-muted" style="font-size:13px">{{ idx + 1 }}</td>
                    <td style="font-size:14px;font-weight:500">{{ item.producto }}</td>
                    <td class="text-muted" style="font-size:13px">{{ item.presentacion }}</td>
                    <td class="text-center fw-bold" style="font-size:15px">{{ Number(item.cantidad) }}</td>
                    <td class="text-end text-muted" style="font-size:13px">
                      <span :class="Number(item.precio) < Number(item.precio_etiqueta) ? 'text-decoration-line-through' : ''">
                        S/ {{ Number(item.precio_etiqueta).toFixed(2) }}
                      </span>
                    </td>
                    <td class="text-end fw-bold" :class="Number(item.precio) < Number(item.precio_etiqueta) ? 'text-danger' : ''" style="font-size:14px">
                      S/ {{ Number(item.precio).toFixed(2) }}
                    </td>
                    <td class="text-end fw-bold" style="font-size:15px">S/ {{ Number(item.subtotal).toFixed(2) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" class="border-0"></td>
                    <td class="fw-semibold text-end" style="font-size:14px">TOTAL</td>
                    <td class="fw-black text-purple text-end" style="font-size:20px">S/ {{ Number(venta.total).toFixed(2) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

          </template>
        </div>

        <div v-if="venta && !loading" class="modal-footer">
          <button class="btn style-six" data-bs-dismiss="modal">Cerrar</button>
          <button class="btn style-five" @click="imprimir">
            Imprimir <img src="../../../assets/img/icons/download.svg" alt="" />
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../services/api';

export default {
  name: 'SalesDetails',
  props: {
    comprobante: { type: String, default: null },
  },
  data() { return { venta: null, loading: false, error: null }; },
  computed: {
    tipoDoc() {
      if (!this.venta) return '';
      const c = this.venta.comprobante.toUpperCase();
      if (c.startsWith('F')) return 'Factura';
      if (c.startsWith('B')) return 'Boleta';
      return 'Comprobante';
    },
    tipoBadge() {
      if (this.tipoDoc === 'Factura') return 'bg-warning text-dark';
      if (this.tipoDoc === 'Boleta')  return 'bg-primary text-white';
      return 'bg-secondary text-white';
    },
    itemsPositivos() {
      return (this.venta?.items || []).filter(i => Number(i.cantidad) > 0);
    },
    clienteDisplay() {
      const c = this.venta?.cliente;
      if (!c || c.toUpperCase().includes('VARIOS')) return 'Cliente general';
      return c;
    },
    estaVencido() {
      if (!this.venta?.fecha_venc) return false;
      return new Date(this.venta.fecha_venc) < new Date();
    },
  },
  watch: {
    comprobante(val) {
      if (val) this.cargar(val);
    },
  },
  methods: {
    async cargar(comp) {
      this.loading = true; this.error = null; this.venta = null;
      try {
        const res = await api.get(`/ventas/${encodeURIComponent(comp)}`);
        this.venta = res.data.data;
      } catch (e) {
        this.error = e.response?.data?.error || 'Error al cargar el detalle.';
      } finally {
        this.loading = false;
      }
    },
    formatFecha(fecha) {
      if (!fecha) return '—';
      const s = String(fecha).substring(0, 10); return new Date(s + 'T00:00:00').toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    imprimir() { window.print(); },
  },
};
</script>

<style scoped>
.detail-card { background:#f8f7ff; border-radius:8px; padding:10px 14px; height:100%; }
.detail-label { font-size:10px; font-weight:700; letter-spacing:1px; color:#7c3aed; margin-bottom:4px; }
.detail-value { font-size:14px; font-weight:600; color:#1e1b4b; }
.detail-tbl thead th { background:#ede9fe; color:#5b21b6; font-size:12px; font-weight:600; border:none; padding:10px 12px; }
.detail-tbl tbody tr { border-bottom:1px solid #f3f4f6; }
.detail-tbl tfoot td { background:#f8f7ff; padding:12px; }
</style>
